import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import RecipeCard from './RecipeCard';

function MealSlot({ day, meal, recipes }) {
  const droppableId = `${day}-${meal}`;
  return (
    <Droppable droppableId={droppableId}>
      {(provided, snapshot) => (
        <div 
          className={`meal-slot ${meal}`} 
          {...provided.droppableProps} 
          ref={provided.innerRef}
          style={{
            backgroundColor: snapshot.isDraggingOver ? '#e1f5fe' : '#f8f9f9',
            minHeight: '90px',
            border: snapshot.isDraggingOver ? '2px dashed #3498db' : '1px solid #ecf0f1',
            padding: '10px',
            borderRadius: '8px',
            transition: 'all 0.2s ease',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div style={{ fontWeight: '600', marginBottom: '8px', color: '#7f8c8d', fontSize: '0.9rem', textTransform: 'capitalize' }}>
            {meal}
          </div>
          {recipes && recipes.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {recipes.map((r, index) => (
                <Draggable 
                  draggableId={String(r.id)} 
                  key={String(r.id)} 
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        opacity: snapshot.isDragging ? 0.8 : 1
                      }}
                    >
                      <RecipeCard recipe={r} />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          ) : (
            <div style={{ color: '#bdc3c7', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, border: '1px dashed #ddd', borderRadius: '4px', backgroundColor: '#fff' }}>Drop recipes here</div>
          )}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default MealSlot;
